import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'next-i18next';
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay, DialogPanel, DialogTitle } from '@zep/ui';
import { PaymentFailureMetadata } from '../../../payment-tracking/paymentFailure';
import { PaymentFailureContent } from '../../../payment-tracking/PaymentFailureContent';

/**
 *  재시도하는 모달, x 버튼이 필요해서 alert 본따서 만들엇습니다
 * */
const RetryDialogInner = ({
  onRetry,
  errorCode,
  paymentFailure
}: {
  onRetry: () => void;
  errorCode: string;
  paymentFailure?: PaymentFailureMetadata;
}) => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    visible,
    remove
  } = useModal();
  const openInquiry = () => {
    window.open(t('subscription:payment.alertFailPay.buttonRetryLink'));
  };
  const handleRetry = () => {
    onRetry();
    remove();
  };
  return <Dialog open={visible} maxWidth={'320px'} onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => e.stopPropagation()} onClose={remove} data-sentry-element="Dialog" data-sentry-component="RetryDialogInner" data-sentry-source-file="PaymentRetryDialog.tsx">
      <DialogOverlay data-sentry-element="DialogOverlay" data-sentry-source-file="PaymentRetryDialog.tsx" />
      <DialogPanel data-sentry-element="DialogPanel" data-sentry-source-file="PaymentRetryDialog.tsx">
        <DialogHeader onClose={remove} data-sentry-element="DialogHeader" data-sentry-source-file="PaymentRetryDialog.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="PaymentRetryDialog.tsx">
            {t('subscription:payment.alertFailPay.title')}
          </DialogTitle>
        </DialogHeader>
        <DialogContent preLine data-sentry-element="DialogContent" data-sentry-source-file="PaymentRetryDialog.tsx">
          {paymentFailure ? <PaymentFailureContent metadata={paymentFailure}>
              {t('subscription:payment.alertFailPay.descriptionErrorCode', {
            errorCode
          })}
            </PaymentFailureContent> : t('subscription:payment.alertFailPay.descriptionErrorCode', {
          errorCode
        })}
        </DialogContent>
        <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="PaymentRetryDialog.tsx">
          <Button size="md" variant={'sub'} onClick={openInquiry} data-sentry-element="Button" data-sentry-source-file="PaymentRetryDialog.tsx">
            {t('subscription:payment.alertFailPay.buttonContact')}
          </Button>
          <Button size="md" onClick={handleRetry} data-sentry-element="Button" data-sentry-source-file="PaymentRetryDialog.tsx">
            {t('subscription:payment.alertFailPay.buttonRetry')}
          </Button>
        </DialogFooter>
      </DialogPanel>
    </Dialog>;
};
export const PaymentRetryDialog = NiceModal.create(RetryDialogInner);